import React, { useState } from 'react';
import 'react-day-picker/dist/style.css';
import styled from 'styled-components';
import Dropdown from './Dropdown';
import { createSeguimiento, updateSeguimiento } from "../../endpoints"
import Swal from "sweetalert2";

export default function ModalAddSeguimiento(
  {
    onClose,
    contacto,
    stopPropagation,
    getContactID,
    idSeguimientoAEditar,
    setEditarSeguimiento,
    setIdSeguimiendoAEditar,
    editarSeguimiento,
    user
  }) {
  const [detalleDelMotivo, setDetalleDelMotivo] = useState('');
  const [motivoRechazo, setMotivoRechazo] = useState(idSeguimientoAEditar?.motivoRechazo && editarSeguimiento ? idSeguimientoAEditar?.motivoRechazo : null);
  const [status, setStatus] = useState(idSeguimientoAEditar?.estadoDePoliza && editarSeguimiento ? idSeguimientoAEditar?.estadoDePoliza : null);
  const [statusCotizacion, setStatusCotizacion] = useState(idSeguimientoAEditar?.estadoCotizacion && editarSeguimiento ? idSeguimientoAEditar?.estadoCotizacion : null);
  const [observaciones, setObservaciones] = useState(idSeguimientoAEditar?.detalle && editarSeguimiento ? idSeguimientoAEditar?.detalle : null)
  const [anotacion, setAnotacion] = useState(idSeguimientoAEditar?.anotaciones && editarSeguimiento ? idSeguimientoAEditar?.anotaciones : null)

  const statusOptionsList = [
    "No le interesa",
    "Alta de poliza",
    "Sin respuesta",
    "Esperando Respuesta",
    "Esperando Datos",
  ]
  const statusCotizacionOptions = [
    "Cotización no enviada",
    "Cotización enviada",

  ]
  const motivosRechazo = [
    "Por costo ",
    "Por cobertura",
    "Otros motivos",
  ]

  const handleGuardar = () => {
    if (editarSeguimiento) {
      if (
        status &&
        statusCotizacion &&
        anotacion &&
        observaciones &&
        contacto?.id &&
        user?.id
      ) {
        updateSeguimiento({
          detalle: observaciones,
          estadoCotizacion: statusCotizacion,
          estadoDePoliza: status,
          anotaciones: anotacion,
          contactId: contacto?.id,
          userId: user?.id,
          idSeguimiento: idSeguimientoAEditar.id,
          detalleDelMotivo: detalleDelMotivo,
          motivosRechazo: motivoRechazo

        }).then((res) => {
          if (res.status === 200 || res.status === 201) {
            Swal.fire({
              icon: "success",
              title: "Se creo con exito",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
              customClass: {
                title: 'my-custom-title-class'
              }
            });
            getContactID().then(() => {
              setEditarSeguimiento(false)
              setIdSeguimiendoAEditar(null)
              onClose()
            })

          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
              customClass: {
                title: 'my-custom-title-class'
              }
            });
          }
        })
      }
    } else {
      if (
        status &&
        statusCotizacion &&
        anotacion &&
        observaciones &&
        contacto?.id &&
        user?.id
      ) {
        createSeguimiento({
          detalle: observaciones,
          estadoCotizacion: statusCotizacion,
          estadoDePoliza: status,
          anotaciones: anotacion,
          contactId: contacto?.id,
          userId: user?.id,
          detalleDelMotivo: detalleDelMotivo,
          motivosRechazo: motivoRechazo
        }).then((res) => {
          if (res.status === 200 || res.status === 201) {

            getContactID()
            Swal.fire({
              icon: "success",
              title: "Se creo con exito",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
              customClass: {
                title: 'my-custom-title-class'
              }
            });
            getContactID().then(() => {
              onClose()
            })

          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
              customClass: {
                title: 'my-custom-title-class'
              }
            });
          }
        })
      }
    }

  };


  const handleCancelar = () => {
    onClose();
    setEditarSeguimiento(false)
  };

  const handleTextAreareaOnChange = (e) => {
    if (e.target.name === "anotacion") {
      setAnotacion(e.target.value)
    }
    if (e.target.name === "detalle") {
      setObservaciones(e.target.value)
    }
    if (e.target.name === "detalleDelMotivo") {
      setDetalleDelMotivo(e.target.value)
    }

  }

  return (
    <ModalWrapper onClick={handleCancelar}>
      <ModalContent onClick={stopPropagation}>
        <span>Formulario de Seguimientos *</span>
        <span>Detalle del pedido *</span>
        <TextArea
          name="detalle"
          placeholder=''
          value={observaciones || ""}
          onChange={(e) => handleTextAreareaOnChange(e)}
        />

        <span style={{
          fontFamily: "'Montserrat', sans-serif"
        }}>Cotización *</span>

        <Dropdown
          Containerwidth={'100%'}
          options={statusCotizacionOptions}
          selectedOption={statusCotizacion}
          setSelectedOption={setStatusCotizacion}
        />
        <span style={{
          fontFamily: "'Montserrat', sans-serif"
        }}>Estado*</span>
        <Dropdown
          Containerwidth={'100%'}
          options={statusOptionsList}
          selectedOption={status}
          setSelectedOption={setStatus}
        />

        {
          status === "No le interesa" ?
            <>
              <span style={{
                fontFamily: "'Montserrat', sans-serif"
              }}>Motivo*</span>
              <Dropdown
                Containerwidth={'100%'}
                options={motivosRechazo}
                selectedOption={motivoRechazo}
                setSelectedOption={setMotivoRechazo}
              />
            </>
            : null
        }

        {
          motivoRechazo === "Otros motivos" ?
            <>
              <span>Detalle del motivo *</span>
              <TextArea
                name="detalleDelMotivo"
                placeholder=''
                value={detalleDelMotivo || ""}
                onChange={(e) => handleTextAreareaOnChange(e)}
              />
            </>
            : null
        }

        <span>Anotaciones *</span>
        <TextArea
          name="anotacion"
          placeholder=''
          value={anotacion || ""}
          onChange={(e) => handleTextAreareaOnChange(e)}
        />

        <ButtonGroup>
          <Button style={{
            backgroundColor: '#780000',
          }} onClick={handleCancelar}>CANCELAR</Button>
          <Button style={{
            backgroundColor: '#003049',
          }} onClick={handleGuardar}>GUARDAR</Button>
        </ButtonGroup>
      </ModalContent>
    </ModalWrapper>
  );
}

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: -webkit-fill-available;
  max-width:400px;
  padding: 20px auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  max-height:80vh;
  overflow-y: auto;
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  gap:16px;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  margin-top: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight:500;
  font-family: 'Montserrat', sans-serif;
  &:hover {
    background-color: #0056b3;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  width:-webkit-fill-available;
  justify-content: space-between;
  align-items: center;
`;

const TextArea = styled.textarea`
  margin-top: 10px;
  padding: 10px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  min-height:80px;
  resize: none;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
  }
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;